import { render, staticRenderFns } from "./FuelConsumptionCard.vue?vue&type=template&id=f8d1948e&scoped=true"
import script from "./FuelConsumptionCard.vue?vue&type=script&lang=js"
export * from "./FuelConsumptionCard.vue?vue&type=script&lang=js"
import style0 from "./FuelConsumptionCard.vue?vue&type=style&index=0&id=f8d1948e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d1948e",
  null
  
)

export default component.exports